import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import {
  unsubscribeOrgPreferenceRoute,
  type unsubscribePreferenceRoute,
} from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { UnsubscribePageLoadable } from './UnsubscribePageLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<
    typeof unsubscribePreferenceRoute | typeof unsubscribeOrgPreferenceRoute
  >,
) {
  await UnsubscribePageLoadable.load();
}

export default function UnsubscribeHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <UnsubscribePageLoadable />;
}
